export default __webpack_public_path__ + "static/media/stars.2362aff9.jpg";